module.exports = __webpack_public_path__ + "img/emoji_63.a5021c23.png";